import { experiencesService } from '@/services/experiences.service.js';

const state = {
  getExperiencesOutput: null,
  getExperienceByIdOutput: null,
  createExperienceOutput: null,
  updateExperienceOutput: null,
  deleteExperienceByIdOutput: null
};

const mutations = {
  setGetExperiencesOutput(state, payload) {
    state.getExperiencesOutput = payload;
  },
  setGetExperienceByIdOutput(state, payload) {
    state.getExperienceByIdOutput = payload;
  },
  setCreateExperienceOutput(state, payload) {
    state.createExperienceOutput = payload;
  },
  setUpdateExperienceOutput(state, payload) {
    state.updateExperienceOutput = payload;
  },
  setDeleteExperienceByIdOutput(state, payload) {
    state.deleteExperienceByIdOutput = payload;
  }
};

const actions = {
  async getExperiences({ commit }, payload) {
    try {
      // Support both old format (just input) and new format ({ input, language })
      let input, language = null;
      if (payload && payload.input !== undefined) {
        input = payload.input;
        language = payload.language || null;
      } else {
        input = payload;
      }
      const response = await experiencesService.getList(input, language);
      commit('setGetExperiencesOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching experiences list:', error);
      throw error;
    }
  },
  
  async getById({ commit }, id) {
    try {
      const response = await experiencesService.getById(id);
      commit('setGetExperienceByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching experience by id:', error);
      throw error;
    }
  },
  
  async create({ commit }, data) {
    try {
      const response = await experiencesService.create(data);
      commit('setCreateExperienceOutput', response);
      return response;
    } catch (error) {
      console.error('Error creating experience:', error);
      throw error;
    }
  },
  
  async update({ commit }, data) {
    try {
      const response = await experiencesService.update(data);
      commit('setUpdateExperienceOutput', response);
      return response;
    } catch (error) {
      console.error('Error updating experience:', error);
      throw error;
    }
  },
  
  async deleteExperienceById({ commit }, id) {
    try {
      const response = await experiencesService.delete(id);
      commit('setDeleteExperienceByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error deleting experience:', error);
      throw error;
    }
  }
};

const getters = {
  experiences: state => state.getExperiencesOutput?.data || [],
  experience: state => state.getExperienceByIdOutput || null
};

export const experiences = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

